export var TextFieldState;
(function (TextFieldState) {
    TextFieldState["DEFAULT"] = "default";
    TextFieldState["EMPTY"] = "empty";
    TextFieldState["ERROR"] = "error";
    TextFieldState["DISABLED"] = "disabled";
})(TextFieldState || (TextFieldState = {}));
export var TextFieldType;
(function (TextFieldType) {
    TextFieldType["DEFAULT"] = "text";
    TextFieldType["EMAIL"] = "email";
    TextFieldType["PASSWORD"] = "password";
    TextFieldType["NUMBER"] = "number";
    TextFieldType["SEARCH"] = "search";
    TextFieldType["TELEPHONE"] = "tel";
})(TextFieldType || (TextFieldType = {}));
//# sourceMappingURL=types.js.map